import InputTextComponent from "presentation/components/Shared/InputTextComponent";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import "./index.css";
import { ConfirmDialog } from "primereact/confirmdialog";
import { confirmDialog } from "primereact/confirmdialog";
import DistanceGrid from "./DistacyGrid";
import { useDistancyCreateStore } from "presentation/stores/use-distancy-create-store";
import InputNumberComponent from "presentation/components/Shared/InputNumberComponent";
import {
  useCreateDistanceMutation,
  useDeleteDistanceMutation,
  usePopulateDistanceMutation,
  useUpdateDistanceMutation,
} from "presentation/hooks/use-query-distancy";
import { useDistanceDeleteStore } from "presentation/stores/use-distancy-delete-store";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { EMAIL } from "domain/enum/email";
import { Distance } from "domain/entities/distance";
import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import Spinner from "presentation/components/Shared/Spinner";

const DistanceSetting: React.FC = () => {
  const toast = useRef<Toast>(null);

  const confirmAction = (message: string, acceptCallback: () => void) => {
    confirmDialog({
      message: message,
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: acceptCallback,
    });
  };

  const { distance, setDistance } = useDistancyCreateStore();
  const [createDistance, setCreateDistance] = useState<Partial<Distance>>({
    locationOrigin: "",
    locationDestination: "",
    distanceKm: 0,
  });

  const { distanceToDelete, setDistanceToDelete } = useDistanceDeleteStore();

  const {
    mutate: createDistanceMutation,
    error: creationDistanceError,
    isError: isCreationDistanceError,
    isSuccess: isCreationDistanceSuccess,
    data: distanceCreated,
  } = useCreateDistanceMutation();

  
const {
    mutate: populateDistanceMutation,
    error: populateDistanceError,
    isError: isPopulateDistanceError,
    isSuccess: isPopulateDistanceSuccess,
    data: distancePopulated,
    isPending: isPopulatePending,
    reset: resetPopulateDistanceMutation
  } = usePopulateDistanceMutation();

  const { email: userEmployeeEmail, userPermissions } = useAuthStore();

  const { distanceType, setDistanceType } =
      useParameterStore();

  const handleCreate = async () => {
    if (createDistance) {
      createDistance.lastModifiedBy = userEmployeeEmail || EMAIL;
      createDistanceMutation(createDistance);
    }
  };

  const {
    mutate: updateDistanceMutation,
    error: updatingDistanceError,
    isError: isUpdatingDistanceError,
    isSuccess: isUpdatingDistanceSuccess,
  } = useUpdateDistanceMutation();

  const { data: parameters } = useParameterByFilter({
      limit: 1000,
      sortBy: "value",
    } as BaseInputFilter);

  const handleUpdate = async () => {
    if (distance) {
      distance.lastModifiedBy = userEmployeeEmail ?? EMAIL;
      updateDistanceMutation(distance);
    }
  };

  const {
    mutate: deleteDistanceMutation,
    error: deletingDistanceError,
    isError: isDeletingDistanceError,
    isSuccess: isDeletingDistanceSuccess,
  } = useDeleteDistanceMutation();

  useEffect(() => {
    setDistanceType(
      parameters?.data?.filter((item) => item.type === "distanceType")
    );
  }, [parameters]);

  useEffect(() => {
    if (distanceToDelete && distanceToDelete.id !== "")
      deleteDistanceMutation(distanceToDelete);
  }, [distanceToDelete, deleteDistanceMutation]);

  useEffect(() => {
    if (isUpdatingDistanceSuccess) {
      const successMessage = "Distância atualizada com sucesso";

      toast.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: successMessage,
        life: 2000,
      });
    }
    setDistance({locationOrigin: "", locationDestination: "", distanceKm: 0, id: ""});
  }, [isUpdatingDistanceSuccess]);

  useEffect(() => {
    if (isUpdatingDistanceError) {
      let message = [];
      message.push(updatingDistanceError.message);
      message = updatingDistanceError.response.data.metadata.errors;
      console.log("message", message);
      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 2000,
        });
      });
    }
  }, [updatingDistanceError, isUpdatingDistanceError]);

  useEffect(() => {
    if (isDeletingDistanceSuccess) {
      const successMessage = "Distância eliminada com sucesso";

      toast.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: successMessage,
        life: 2000,
      });

      setDistanceToDelete({locationOrigin: "", locationDestination: "", distanceKm: 0, id: ""});

    }
  }, [isDeletingDistanceSuccess]);

  useEffect(() => {
    if (isDeletingDistanceError) {
      let message = [];
      message.push(deletingDistanceError.message);
      message = deletingDistanceError.response.data.metadata.errors;
      console.log("message", message);
      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 2000,
        });
      });
    }
  }, [deletingDistanceError, isDeletingDistanceError]);

  useEffect(() => {
    if (isCreationDistanceSuccess) {
      const successMessage = "Distância criada com sucesso";

      toast.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: successMessage,
        life: 2000,
      });

      setCreateDistance({locationOrigin: "", locationDestination: "", distanceKm: 0});

    }
  }, [isCreationDistanceSuccess]);

  useEffect(() => {
    if (isCreationDistanceError) {
      let message = [];
      message.push(creationDistanceError.message);
      message = creationDistanceError.response.data.metadata.errors;
      console.log("message", message);
      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 2000,
        });
      });
      setTimeout(() => {
        resetPopulateDistanceMutation();
      }, 0);
    }
  }, [creationDistanceError, isCreationDistanceError]);

   useEffect(() => {
    if (isPopulateDistanceSuccess) {
      const successMessage = "Tabela atualizada, já com todas as distâncias dos trabalhadores remotos";
      toast.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: successMessage,
        life: 2000,
      });
      setTimeout(() => {
        resetPopulateDistanceMutation();
      }, 0);
    }
  }, [isPopulateDistanceSuccess]);

  useEffect(() => {
    if (isPopulateDistanceError) {
      let message = [];
      message.push(populateDistanceError.message);
      message = populateDistanceError.response.data.metadata.errors;
      console.log("message", message);
      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 2000,
        });
      });
    }
  }, [populateDistanceError, isPopulateDistanceError]);

  if (isPopulatePending) return <Spinner />;

  return (

    <div className="parameter-grid ">
      <div className="parameter-1-col">
        <DropdownComponent
          options={distanceType}
          label={`Tipo`}
          fieldName="type"
          currentObject={createDistance}
          getValue={createDistance?.type ?? ""}
          setValue={(value) => setCreateDistance(value)}
        />
      </div>
      <div className="parameter-1-col">
        <InputTextComponent
          label="Origem"
          fieldName="locationOrigin"
          currentObject={createDistance}
          getValue={createDistance?.locationOrigin}
          setValue={(value) => setCreateDistance(value)}
        />
      </div>

      <div className="parameter-1-col">
        <InputTextComponent
          label="Destino"
          fieldName="locationDestination"
          currentObject={createDistance}
          getValue={createDistance?.locationDestination}
          setValue={(value) => setCreateDistance(value)}
        />
      </div>
      <div className="parameter-1-col">
        <InputNumberComponent
          label="Distância"
          fieldName="distanceKm"
          currentObject={createDistance}
          getValue={createDistance?.distanceKm}
          setValue={(value) => setCreateDistance(value)}
        />
      </div>

      <div className="parameter-1-col combine-buttons">
        <>
          <Button
            label={"Adicionar"}
            onClick={() =>
              confirmAction("Deseja criar uma nova distância?", handleCreate)
            }
            className="button-size "
            disabled={
              !createDistance ||
              !createDistance.locationOrigin ||
              !createDistance.locationDestination ||
              !createDistance.distanceKm
            }
          />
        </>

      </div>

      <div className="timesheet-4-cols">
        <DistanceGrid 
          onSave={handleUpdate} 
          populateDistanceMutation={populateDistanceMutation}
          populateDistanceError={populateDistanceError}
          isPopulateDistanceError={isPopulateDistanceError}
          isPopulateDistanceSuccess={isPopulateDistanceSuccess}
          distancePopulated={distancePopulated}
          isPopulatePending={isPopulatePending}
          />
      </div>

      <Toast ref={toast} position="bottom-right" />

      <ConfirmDialog />
    </div>
  );
};
export default DistanceSetting;
